import React from 'react';
import { Link } from 'react-router-dom';
import { useEvents } from '../../hooks/useEvents';
import { useJoinVisible } from '../../hooks/useJoinVisible';
import { isEventUpcoming, upcomingQueryStart } from '../../utils/eventTime';
import EventCard from '../shared/EventCard';

export default function EventsTeaser() {
  // Nur Kommendes laden - der Teaser zeigt ohnehin nichts anderes.
  const { events, loading } = useEvents({ from: upcomingQueryStart() });
  const upcoming = events.filter((e) => isEventUpcoming(e)).slice(0, 3);
  const joinVisible = useJoinVisible();

  return (
    <section className="mt-section mt-section--alt" id="termine">
      <div className="mt-container">
        <div className="mt-head">
          <span className="mt-kicker">Kalender</span>
          <h2>Was als Nächstes ansteht</h2>
          <p className="mt-lead">
            Unsere Termine sind offen - auch wenn du noch kein Mitglied bist, kannst du bei den
            öffentlichen Treffen einfach vorbeikommen.
          </p>
        </div>

        {loading && (
          <div className="mt-loading">
            <div className="mt-spinner" />
          </div>
        )}

        {!loading && upcoming.length === 0 && (
          <div className="mt-card mt-empty">
            <p>
              Gerade steht kein öffentlicher Termin fest. Die nächste Ausfahrt planen wir
              bereits - schau bald wieder rein
              {joinVisible ? ' oder werde Mitglied, dann erfährst du es zuerst.' : '.'}
            </p>
            {joinVisible && (
              <Link to="/mitglied-werden" className="mt-btn mt-btn--secondary mt-btn--sm">
                Mitglied werden
              </Link>
            )}
          </div>
        )}

        {!loading && upcoming.length > 0 && (
          <>
            <div className="mt-grid">
              {upcoming.map((event) => (
                // Ohne `to` gäbe es hier keinen Weg zum vollen Text - die
                // Beschreibung ist auf der Karte gekürzt.
                <EventCard key={event.id} event={event} to={`/termine/${event.id}`} />
              ))}
            </div>
            <p className="mt-center mt-teaser__more">
              <Link to="/termine" className="mt-btn mt-btn--ghost">
                Alle Termine ansehen
              </Link>
            </p>
          </>
        )}
      </div>
    </section>
  );
}
